export const vatsListFields: {
	key: string;
	label: string;
	formatter?: (val: any) => string;
}[] = [
	{ key: 'id', label: 'Id' },
	{ key: 'label', label: 'Label' },
	{
		key: 'status',
		label: 'Status',
		formatter: (status: string | null) => status ?? 'No status',
	},
];
